<template>
  <div>
    <NavBar />
    <div class="container text-center">
      <h1>Not Found</h1>
      <p>This test link is <b>invalid</b> or has <b>expired</b>.</p>
      <p>Please contact your test administrator.</p>
    </div>
  </div>
</template>

<script>
import NavBar from "@/views/tests/NavBar.vue";

export default {
  components: {
    NavBar,
  },
};
</script>
